import type { Spine } from "@esotericsoftware/spine-pixi-v8";

/**
 * Hide a slot's art for good — `skeleton.setAttachment(slot, "")` on a REALTIME skeleton.
 * Clears the live attachment AND strips the slot's attachments from every skin, so the clips'
 * attachment timelines can never bring the guide region back. Used for the `number_placeholder`
 * guides (win label, big win, feature panels) and the cannon's `cannonball_placeholder*` rounds.
 */
export function hideSlotAttachments(spine: Spine, slotName: string): boolean {
  const slot = spine.skeleton.findSlot(slotName);
  if (!slot) return false;
  const slotIndex = slot.data.index;
  for (const skin of spine.skeleton.data.skins) {
    const attachments = skin.attachments[slotIndex];
    if (attachments) for (const name of Object.keys(attachments)) skin.removeAttachment(slotIndex, name);
  }
  slot.setAttachment(null);
  return true;
}

/** Hide every slot whose name starts with `prefix` (returns the count). */
export function hideSlotAttachmentsByPrefix(spine: Spine, prefix: string): number {
  let count = 0;
  for (const slot of spine.skeleton.slots) {
    if (slot.data.name.startsWith(prefix) && hideSlotAttachments(spine, slot.data.name)) count += 1;
  }
  return count;
}
